import { render, staticRenderFns } from "./DashboardSixMonthlySafety.vue?vue&type=template&id=56a113e4&"
import script from "./DashboardSixMonthlySafety.vue?vue&type=script&lang=js&"
export * from "./DashboardSixMonthlySafety.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports